module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "infoTop"
  }, [_c('i', {
    staticClass: "iconfont icon-changfangxingbiaoqian"
  }), _vm._v(" "), _vm._v("\n    " + _vm._s(_vm.$t('fangTXQ_market_sales')) + "\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "infoContent twocol"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_salesman')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.salesman))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_rsvTypeName')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.rsvTypeName))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_market')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.market))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_src')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.src))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_cmscode')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.cmscode))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_channel')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.channel))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_payCode')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.payCode))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_crsNo')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.crsNo))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_packagesDis')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.packagesDis))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('fangTXQ_creditMan')) + ":\n      "), _c('span', {
    staticClass: "infoVal"
  }, [_vm._v(_vm._s(_vm.masterBase.creditMan))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_otaRsvNo')) + ":\n      "), _c('span', {
    staticClass: "infoVal",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.masterBase.otaRsvNo))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1b67e415","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/fangTXQ-comp/marketInfo.vue
// module id = 1742
// module chunks = 107